import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.GettingStartedPage.AdditionalResources', {
    title: 'Additional resources',
    videoTutorials: 'Video tutorials',
    knowledgeBase: 'Knowledge Base',
    webinars: 'Product demo webinars',
});
